<script setup lang="ts">
import { ref, watch } from "vue";

const animate = ref(true);

defineProps<{
	id?: string | number;
}>();

watch(
	() => animate.value,
	() => {
		animate.value = false;
		setTimeout(() => {
			animate.value = true;
		}, 0);
	},
);
</script>

<template>
	<div class="opacity-animation" :key="id">
		<slot name="opacityLoader" />
	</div>
</template>

<style scoped lang="scss">
.opacity-animation {
   animation: louderOpacity .6s cubic-bezier(0.55, 0.055, 0.675, 0.19) forwards;
   height: 100%;
}

@keyframes louderOpacity {
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 1; transform: translateY(0px); }
}
</style>
